const constants = {
    UPDATE_TIME: 20171019, //本次constants数据字典更新日期
    //基金：开放式标志、性别、基金类型、风险等级、定期定额状态、基金状态
    // 开放式标志
    OPENFUND_FLAG: {
        '1': '开放式',
        '0': '封闭式'
    },
    // 性别
    OPENFUND_SEX: {
        BANKTOSTOCK: '1', // 银转证
        STOCKTOBANK: '2', // 证转银
        STOCKBALANCE: '3', // 证券余额查询
        BANKBALANCE: '4' // 银行余额查询
    },
    // 基金类型
    FUND_TYPE: {
        '0': '无类型', // 国内基金无类型
        '1': '股票型', // 国内基金股票型
        '2': '混合型', // 国内基金混合型
        '3': '债券型', // 国内基金偏债型
        '4': '债券型', // 国内基金纯债型
        '5': '保本型', // 国内基金保本型
        '6': '货币型', // 国内基金货币型
        '7': '分级基金', // 国内基金分级基金
        '8': '无类型', // 国内基金其他类型
        '21': 'QDII', // QDII股票型
        '22': 'QDII', // QDII混合型
        '23': 'QDII', // QDII偏债型
        '24': 'QDII', // QDII纯债型
        '27': 'QDII' // QDII分级基金
    },
    //单独列出货币型数据值
    FUND_TYPE_HBX: '6',
    // 风险等级
    OPENFUND_FXDJ: {
        '1': 'R1', //低风险
        '2': 'R2', //中低风险
        '3': 'R3', //中风险
        '4': 'R4', //中高风险
        '5': 'R5' //高风险
    },
    // 风险等级描述
    OPENFUND_FXDJMS: {
        "1": "低风险", //低风险
        "2": "中低风险", //中低风险
        "3": "中风险", //中风险
        "4": "中高风险", //中高风险
        "5": "高风险", //高风险
    },
    // 定期定额状态
    OPENFUND_DQDEZT: {
        '0': '不允许定投',
        '1': '允许定投'
    },
    // 基金状态
    OPENFUND_JJZT: {
        '0': '可申购赎回', //S、SH
        '1': '发行', //R
        '4': '停止申购赎回',
        '5': '停止申购', //SH
        '6': '停止赎回', //S
        '8': '基金终止',
        '9': '基金封闭'
    },
    //可以申购的基金状态
    OPENFUND_JJZT_CANSG: ['0', '6'],
    //可以认购的基金状态
    OPENFUND_JJZT_CANRG: ['1'],
    //可以赎回的基金状态
    OPENFUND_JJZT_CANSH: ['0', '5'],
    //能够定投产品状态
    OPENFUND_DQDEZT_CANDT: '1',
    //私募基金产品披露周期
    PRIFUND_CPPLZQ: {
        '0': '近一周涨幅',
        '1': '近一月涨幅',
        '2': '近一季涨幅',
        '3': '近半年涨幅',
        '4': '近一年涨幅',
        '5': '不定期涨幅',
        '': ''
    },
    /**********************************新版商城******************************************/
    //产品类型-搜索结果分区使用
    product_type: {
        '2lcb': '理财宝',
        '6hjb': '黄金宝',
        '5nxb': '牛熊宝',
        '3yyc': '月月财',
        '8other': 'OTC其他',
        '7sm': '高端',
        '4zg': '资管',
        '1fund': '基金'
    },
    //产品阶段
    product_status: {
        '0': '在售',
        '1': '预售',
        '2': '结束',
		'3': '往期',
        '': '--'
    },
    //基金账户状态
    JJ_ACCOUNT_STATUS: {
        COMMON: '0', // 正常
        FREEZE: '1', // 冻结
        LOSS: '2', // 挂失
        CLOSE_ACCOUNT: '3', // 销户
        CANCLE_REGISTER: '4', // 取消登记
        OPEN_ACCOUNT_ING: '5', // 开户申请
        FREEZE_ING: '6', // 冻结申请
        CLOSE_ING: '7', // 销户申请
        THAW_ING: '8', // 解冻申请
        LOSS_ING: '9', // 挂失申请
        CANCLE_REGISTER_ING: 'A', // 取消登记申请
        CANCLE_LOSE_ING: 'B', // 解挂申请
        LOCAL_CLOSE_ACCOUNT: 'c', // 本地销户
        OPEN_ACCOUNT_FAIL: 'F' // 开户失败
    },
    OVERFX_BUY_TIPS:
        '尊敬的投资者，您所购买的产品风险等级已超出您的风险承受能力，请注意投资风险。如您坚持购买，请前往营业部现场购买。如有疑问请详询在线客服。', //超风险购买提示语句
    EXPIRED_TIPS:
        '尊敬的投资者，您尚未进行风险承受能力测评或者您的风险承受能力测评结果已过期，请先完成风险承受能力测评后再购买产品。如有疑问请详询在线客服。', //风险等级过期描述
    MATCH_FAIL_DESC:
        '尊敬的投资者，根据新的适当性管理要求，请重新进行风险承受能力测评后再购买产品。如有疑问请详询在线客服。', //适当性匹配结果为5的描述
    BUY_HIGHRISK_TIPS:
        '尊敬的投资者，您所购买的产品为高风险产品，根据适当性管理要求，请前往营业部现场购买。如有疑问请详询在线客服。', //购买高风险产品的描述
    LOWRISK_USER_TIPS:
        '尊敬的投资者，您属于最低风险承受能力类别，仅可购买低风险产品，不允许超风险购买。如有疑问请详询在线客服。', //最低风险等级用户超风险购买提示
    XJYJ_SFCG_NOSUPPORT:
        '您的三方存管银行暂不支持T+0快速取现，取现需进行资金保留额度设置，请确认是否仍要开通现金赢家。', //现金赢家不支持快速取现文案
    XJYJ_JGKH_TIPS: '机构客户请前往营业部办理相关业务', //现金赢家机构客户文案
    MAX_SEARCHFX: '5', //最大可查询风险信息
    HIGHEST_RISKLEVEL: '5', //高风险等级
    USER_MINIMUM_RISK: '6',
    DEFAULTCODE: '1', //基金定投的默认周期
    SDX_MATCH_RESULT: {
        EXPIRED: '0', // 未评测/评测已过期
        SUCCESS: '1', //正常
        OVER: '2', //超风险（允许委托，但需客户确认适当性不匹配)
        DEFAULT: '3', //默认评测
        UNSUPPORT: '4', //未支持
        FAIL: '5' // 失败（超风险且存在禁止三要素，不允许交易)
    },
    SDX_MATCH_RESULT_DETAIL: {
        //适当性匹配详情 ：投资品种、投资期限、风险等级
        SUCCESS: '0',
        FAIL: '1'
    },
    SFPD_SDXBSD_FXCFX: false, //是否判断适当性不适当情况下的风险等级超风险 true判断、false不判断
    CPXX_FGKZS: {
        //产品信息-非公开展示
        FGK: '0', //0不公开
        GK: '1' //公开
    },
    CPXX_XCFXJS: {
        //产品信息-现场风险揭示 0否 1是
        N: '0', //0否
        Y: '1' //1是
    },
    CUST_INVESTER_TYPE: {
        //投资者类型 0: 普通投资者  1: 专业投资者
        PT: '0', //普通投资者
        ZY: '1' //专业投资者
    },
    CUST_TYPE: {
        //客户类型  0：个人客户  1：机构客户
        GR: '0',
        JG: '1'
    },
    E_CONTR_STATUS: {
        //电子合同状态 1：有效 0：无效 3：待确认
        Y: '1',
        N: '0',
        D: '3' //待确认
    },
    fastCashBank:
        '工商银行、建设银行、中国银行、农业银行、交通银行、招商银行、华夏银行、广发银行、邮储银行、宁波银行、江苏银行、广州银行。', // 快速取现支持的存管银行
    XJYJ_INFO: {
        CPDM: '850011', //现金赢家产品代码
        TA_CODE: '011', //现金赢家基金公司代码
        CPID: '7608', // 现金赢家产品id
        SERVICE_TYPE: '000006' //T+0业务类型代码
    },
    HFT_INFO: {
        CPDM: '004770', //海富通产品代码 - 通财钱包
        TA_CODE: '043', //海富通基金公司代码 - 通财钱包
        TA_SNAME: '海富通' //海富通基金公司简称-电子合同签署页面html使用
    },
    FG_INFO: {
        CPDM: '001982', //富国基金产品代码 - 通财钱包 (富国收益宝货币B)
        TA_CODE: '008', //富国基金公司代码 - 通财钱包
        TA_SNAME: '富国' //富国基金公司简称-电子合同签署页面html使用
    },
    NAVGROWTHCALCTYPE: {
        //净值增长率/万份累计收益计算标识  1 累计收益 0 万份收益
        LJ: '1',
        WF: '0'
    },
    ES_TYCPFL: {
        //通用产品分类
        OTC: '1', //OTC
        ZG: '2', //资管
        SM: '3', //私募
        YH: '4', //银行
        QT: '5' //其他
    },
    ES_TYCPFL_OTC: {
        //通用产品分类-OTC子分类
        NONMAL: '1', //普通OTC
        YYC: '2' //月月财
    },
    ES_TYCPFL_ZG: {
        //通用产品分类-资管子分类
        LC: '1', //理财类
        JZ: '2' //净值类
    },
    ES_SYLX: {
        //收益类型
        GD: '1', //固定收益
        FD: '2' //浮动收益
    },
    ES_CPFLBM: {
        //产品分类别名
        LCB: '1', //1	理财宝	理财宝产品|070101
        ZSB: '2', //2	指数宝	指数宝产品|070102
        NXB: '3', //3	牛熊宝	牛熊宝产品|070103
        QTSYPZ: '4', //4	其他收益凭证	其他收益凭证|070104
        ZGSSYPZ: '5', //5	子公司收益凭证	子公司收益凭证|070105
        HJB: '6', //6	黄金宝	黄金宝产品|070106
        QBLC: '7', //7	理财宝Q版	Q版理财宝产品|070107
        KZR: '8', //8	可转让	可转让产品|070201
        YYY: '9', //9	月月赢	月月赢|080101
        YYS: '10', //10	月月升	月月升|080102
        BNS: '11', //11	半年升	半年升|080103
        NNS: '12', //12	年年升	年年升|080104
        XXL: '13', //13	鑫系列	鑫系列|080105
        HTZGHBX: '14', //14	货币型	海通资管货币型|080106
        JJS: '15', //15	季季升	季季升|080107
        YYC: '16', //16	月月财	月月财|08010A
        HTZGGPX: '17', //17	股票型	海通资管股票型|080201
        HTZGZQX: '18', //18	债券型	海通资管债券型|080202
        HTZGHHX: '19', //19	混合型	海通资管混合型|080203
        JHJH: '20', //20	集合计划	集合计划|080501
        DXJH: '21', //21	定向计划	定向计划|080502
        ZXJH: '22', //22	专项计划	专项计划|080503
        OTCDX: '23', //23	OTC代销	OTC代销|080601
        PTDX: '24', //24	普通代销	普通代销|080602
        JJZH: '25' //25	基金专户	基金专户|011200
    },
    REPRODUCT_TYPE: {
        GMJJ: '1', // 公募基金
        TYCP: '2' // 通用产品
    },
	NETHALL_TYPE: {
    	// 网厅类型
		OPEN_OTC: '1', // OTC开户
		RISK_ASSESSMENT: '2', // 风险测评
		E_SIGNAGREEMENT: '3', // 电子签名约定书
		OPEN_FUND: '4', // 基金账户开户
	},
}

export default constants



// WEBPACK FOOTER //
// ./src/common/constants.js